import React from 'react';
import Grid from '@material-ui/core/Grid';
import EnhancedTable from './tableReceptions/EnhancedTable';
import SearchReceptions from './Search/SearchReceptions';
import { Title } from '../style';

const Receptions = () => (
  <>
    <Grid container spacing={10}>
      <Grid item md={6}>
        <Title>Réception de marchandises</Title>
      </Grid>
    </Grid>
    <SearchReceptions />
    <EnhancedTable />
  </>
);

export default Receptions;
